import { globalContext, Hotkey as InnerHotkey } from '@rchh/lowcode-editor-core';
import { hotkeySymbol } from '../symbols';
import { IPublicTypeDisposable, IPublicTypeHotkeyCallback, IPublicTypeHotkeyCallbacks, IPublicApiHotkey } from '@rchh/lowcode-types';

const innerHotkeySymbol = Symbol('innerHotkey');

export class Hotkey implements IPublicApiHotkey {
  private readonly [innerHotkeySymbol]: InnerHotkey;
  get [hotkeySymbol](): InnerHotkey {
    if (this.workspaceMode) {
      return this[innerHotkeySymbol];
    }
    const workspace = globalContext.get('workspace');
    if (workspace.isActive) {
      return workspace.window.innerHotkey;
    }

    return this[innerHotkeySymbol];
  }

  constructor(hotkey: InnerHotkey, readonly workspaceMode: boolean = false) {
    this[innerHotkeySymbol] = hotkey;
  }

  get callbacks(): IPublicTypeHotkeyCallbacks {
    return this[hotkeySymbol].callBacks;
  }

  /**
   * @deprecated
   */
  get callBacks() {
    return this.callbacks;
  }

  /**
   * Bind a hotkey
   * @param combos Hotkey combo(s), e.g. ['command + s'], ['ctrl + shift + s']
   * @param callback Callback function
   * @param action
   * @returns
   */
  bind(
      combos: string[] | string,
      callback: IPublicTypeHotkeyCallback,
      action?: string,
    ): IPublicTypeDisposable {
    this[hotkeySymbol].bind(combos, callback, action);
    return () => {
      this[hotkeySymbol].unbind(combos, callback, action);
    };
  }
}